// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".45750cb79100a1d3ae0cd7b4c057345f.js";
};